import React, {PureComponent} from "react"
import {Caption} from "@irati/ui/src/Labels"
import {injectIntl, FormattedMessage, InjectIntl} from "@irati/utils/lang"
import Confirm from "../../../shared/Confirm"

interface Props extends InjectIntl {
  className?: string
}

class ConfirmDeleteComment extends PureComponent<Props> {
  render() {
    const {intl, ...props} = this.props
    const confirmLabel = intl.formatMessage({id: "recognition.popup.comments.confirm.delete.confirmLabel"})
    return (
      <Confirm confirmLabel={confirmLabel} {...props}>
        <Caption>
          <FormattedMessage id="recognition.popup.comments.confirm.delete.message" />
        </Caption>
      </Confirm>
    )
  }
}

export default injectIntl(ConfirmDeleteComment)
